import { render, staticRenderFns } from "./table-pagination.vue?vue&type=template&id=830a637c"
import script from "./table-pagination.vue?vue&type=script&lang=ts"
export * from "./table-pagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports